import {useEffect, useState} from 'react';

// Whether an element's own content width is under `limit`. For what CSS container queries can't
// reach: a portalled menu sits outside the container, so it has to be told. Takes the element as
// state (a callback ref) so it measures one that mounts late. False until first measured.
export function useBelowWidth(element: Element | null, limit: number): boolean {
  const [below, setBelow] = useState(false);

  useEffect(() => {
    if (!element) {
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      if (entry) {
        setBelow(entry.contentRect.width < limit);
      }
    });
    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [element, limit]);

  return below;
}
